import React from "react";
import { FaCalendarAlt, FaFileImage, FaMedal, FaStar, FaTrophy } from "react-icons/fa";
import { GiPodium } from "react-icons/gi";

function StatCard({ icon: Icon, label, value, description }) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-amber-700 shadow-sm dark:bg-white/10 dark:text-amber-200">
          <Icon />
        </div>

        <div>
          <p className="text-2xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>
          <p className="text-sm font-bold text-slate-700 dark:text-white/80">
            {label}
          </p>
          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function PalmaresStats({ stats }) {
  return (
    <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-6">
      <StatCard
        icon={FaTrophy}
        label="Total"
        value={stats.total}
        description="Résultats au palmarès"
      />

      <StatCard
        icon={FaMedal}
        label="Or"
        value={stats.first}
        description="Premières places"
      />

      <StatCard
        icon={GiPodium}
        label="Argent"
        value={stats.second}
        description="Deuxièmes places"
      />

      <StatCard
        icon={FaStar}
        label="Bronze"
        value={stats.third}
        description="Troisièmes places"
      />

      <StatCard
        icon={FaFileImage}
        label="Docs"
        value={stats.documents}
        description="Podiums ou tableaux"
      />

      <StatCard
        icon={FaCalendarAlt}
        label="Année"
        value={stats.bestYear}
        description="Plus récente"
      />
    </div>
  );
}

export default PalmaresStats;